import { Component, OnInit, OnChanges, Input, ViewChild } from '@angular/core';
import { DetailCdaComponent } from './../detail-cda/detail-cda.component';

@Component({
  selector: 'app-education',
  templateUrl: './education.component.html',
  styleUrls: ['./education.component.scss']
})
export class EducationComponent implements OnInit, OnChanges {

  @ViewChild(DetailCdaComponent) detail : DetailCdaComponent;

  @Input() commonDataApi: any;

  categoryType: any;
  categories : any;

  constructor() { }

  async ngOnInit() { }

  ngOnChanges() {
    if (this.commonDataApi !== undefined) {
    this.commonDataApi = this.commonDataApi[0]['accounts'][0]['categories'];
    for (let i = 0 ; i < this.commonDataApi.length ; i++) {
      if (this.commonDataApi[i]['category'] === 'Education') {
        this.categoryType = this.commonDataApi[i]['category'];
        this.categories = this.commonDataApi[i]['entities'];
      }
    }
  }
}
}
